import {useRef} from 'react';

import useScrollMessages from '@/hooks/useScrollMessages';

const ScrollableSlide = ({children}: {children: React.ReactNode}) => {
    const ref = useRef<HTMLDivElement>(null);
    useScrollMessages(ref);
    return (
        <div ref={ref} className='h-full w-dvw overflow-auto'>
            {children}
        </div>
    );
};

export default ScrollableSlide;
